export enum ECountry {
  getCountries = 'state/getCountries',
  getCountry = 'state/getCountry',
  createCountry = 'state/createCountry',
  updateCountry = 'state/updateCountry',
  deleteCountry = 'state/deleteCountry',
}
